import {Menu} from '@mantine/core';
import {useRouter} from 'next/router';
import {type FC, useState} from 'react';
import {PiCaretUpDownBold} from 'react-icons/pi';
import type {RankingMetric} from '../../../../../../core/repositories/columnRepository';
import {cn} from '../../../../../../lib/classname';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {RANKING_METRIC_MAP, RANKING_METRIC_OPTIONS} from '../../constants';
import {COLUMNS_RANKING} from '../../routes';

type Props = {
  className?: string;
};
export const SelectRankingMetric: FC<Props> = ({className}) => {
  const router = useRouter();
  const currentMetric = (router.query.by as RankingMetric) || 'daily_pv';
  const [open, setOpen] = useState(false);

  return (
    <>
      <Menu shadow="md" width={80} opened={open} onChange={setOpen}>
        <Menu.Target>
          <button
            type="button"
            className={cn(
              'text-primary font-bold text-base bg-transparent border-none',
              'inline-flex items-center gap-4',
              className,
            )}
          >
            <span>{RANKING_METRIC_MAP[currentMetric]}ランキング</span>
            <span>
              <PiCaretUpDownBold size="1rem" className="text-primary" />
            </span>
          </button>
        </Menu.Target>

        <Menu.Dropdown>
          {RANKING_METRIC_OPTIONS.map((option) => (
            <Menu.Item
              key={option.value}
              component={CommonLink}
              href={COLUMNS_RANKING(option.value)}
              className={cn(
                'text-center',
                option.value === currentMetric &&
                  'text-white bg-primary hover:bg-primary data-[hovered]:bg-primary',
              )}
            >
              {RANKING_METRIC_MAP[option.value]}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
